var _g, _g2, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhatsNewIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 83,
    viewBox: "0 0 87 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10134_76433)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "#ECF1F7"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10134_76433)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.7978 31.6956C25.5025 32.9964 22.12 35.8764 20.0636 39.4916L26.9572 62.2547L49.6208 55.3912C51.5259 51.6629 52.0538 47.2234 50.7437 42.8974C48.0563 34.0234 38.6795 29.0058 29.7978 31.6956Z",
    fill: "#A4D7FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.894 50.5841L33.9788 43.1036L28.3359 44.8125L34.1666 53.6875C34.8513 54.734 36.1467 55.2026 37.3488 54.8386C39.1558 54.2913 39.931 52.1591 38.894 50.5841Z",
    fill: "#F2994A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7776 35.4414C22.136 36.2414 20.6414 39.0345 21.4414 41.676C22.2414 44.3175 25.0345 45.8121 27.676 45.0122L36.3509 42.385L33.4525 32.8143L24.7776 35.4414Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6493 47.5633L36.3604 42.3821L33.4619 32.8114L44.1395 19.4636L52.6493 47.5633Z",
    fill: "#3876BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3585 27.4327C50.213 27.4767 50.0675 27.5208 49.9366 27.5855L52.9603 37.5697C53.0974 37.5532 53.2505 37.5068 53.396 37.4628C56.1754 36.6211 57.7347 33.683 56.8976 30.919C56.0606 28.1549 53.1301 26.5933 50.3585 27.4327Z",
    fill: "#FF7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2033 18.5373L44.1406 19.4648L52.6504 47.5645L55.713 46.637L47.2033 18.5373Z",
    fill: "#CBF4C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1961 26.4273C39.3109 26.3926 39.4142 26.3195 39.4875 26.2304C39.5922 26.1068 39.6347 25.9434 39.6212 25.7887C39.5978 25.6286 39.5208 25.4848 39.3995 25.3878C39.1469 25.1884 38.7585 25.2308 38.5492 25.4781C38.4545 25.6071 38.4097 25.7627 38.4231 25.9175C38.4389 26.0799 38.5235 26.2214 38.6449 26.3184C38.8008 26.4468 39.0047 26.4853 39.1961 26.4273Z",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4725 30.7648C56.5543 27.7327 53.3782 25.9947 50.336 26.8241L47.7737 18.3635C47.6787 18.0496 47.3395 17.8681 47.0256 17.9632L43.963 18.8907C43.9553 18.893 43.9476 18.8953 43.9423 18.9053C43.927 18.9099 43.914 18.9222 43.891 18.9292C43.8168 18.96 43.7495 19.0138 43.6922 19.073C43.6868 19.083 43.6715 19.0876 43.6585 19.0999L39.5402 24.2423C39.3332 24.4972 39.381 24.8757 39.6359 25.0826C39.8885 25.282 40.2769 25.2396 40.4786 24.9946L43.8865 20.736L51.7355 46.6536L36.8315 41.9056L34.1163 32.9397L38.4813 27.4802C38.6883 27.2253 38.6482 26.8446 38.3933 26.6376C38.1406 26.4382 37.7446 26.4829 37.5529 26.7332L33.107 32.2841L24.6005 34.8603C21.645 35.7553 19.9689 38.8876 20.864 41.843C21.759 44.7984 24.8913 46.4745 27.8467 45.5795L28.0764 45.5099L33.6616 54.0162C34.4871 55.2792 36.0733 55.852 37.5204 55.4138C38.5693 55.0961 39.3803 54.3239 39.7478 53.3015C40.1228 52.2768 39.9866 51.1646 39.3919 50.2497L34.9214 43.437L36.3455 43.0057L52.4589 48.1314C52.4865 48.1397 52.5118 48.1404 52.5294 48.1435C52.5547 48.1442 52.5746 48.1548 52.5999 48.1555C52.6505 48.1569 52.6987 48.1507 52.7547 48.1421C52.77 48.1375 52.7876 48.1405 52.8106 48.1335L55.8732 47.206C56.1871 47.111 56.3686 46.7718 56.2736 46.4579L53.7113 37.9974C56.7125 37.0049 58.3907 33.7968 57.4725 30.7648ZM22.0224 41.5005C21.3199 39.1806 22.6383 36.7167 24.9583 36.0141L33.0589 33.5609L35.6096 41.9831L27.5012 44.4387C25.1813 45.1412 22.725 43.8205 22.0224 41.5005ZM38.3967 50.9105C38.7852 51.5033 38.8714 52.2295 38.6302 52.896C38.3891 53.5625 37.854 54.0589 37.1802 54.263C36.2384 54.5482 35.2137 54.1731 34.6721 53.3508L29.2785 45.1459L33.727 43.7987L38.3967 50.9105ZM54.9611 46.2368L53.047 46.8165L44.885 19.8653L46.7992 19.2856L49.3683 27.7691L52.392 37.7533L54.9611 46.2368ZM53.3735 36.8542L50.6814 27.9649C53.0858 27.3203 55.5959 28.7084 56.3217 31.1049C57.0474 33.5014 55.7315 36.0565 53.3735 36.8542Z",
    fill: "#505050"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58 25L61 22",
    stroke: "#F2994A",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61 30.4922L64.9717 29.0004",
    stroke: "#F2994A",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61 36L65.0465 37.2752",
    stroke: "#F2994A",
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10134_76433",
    x: 0,
    y: 0,
    width: 87,
    height: 83,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 7,
    dy: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.784253 0 0 0 0 0.894808 0 0 0 0 0.945833 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10134_76433"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10134_76433",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10134_76433"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(15.0625 25.8516) rotate(-16.8485)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsNewIcon);
export default __webpack_public_path__ + "static/media/WhatsNewIcon.97d753af62b0ebb2e04acd5fbed596b8.svg";
export { ForwardRef as ReactComponent };